"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const lodash_1 = require("lodash");
const AlphabeticalPagination = (props) => {
    const alphabetString = [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "\u00C6",
        "\u00D8",
        "\u00C5",
    ];
    const grouped = (0, lodash_1.groupBy)(props.categoryList.filter((x) => x.lastName.length > 0), (x) => x.lastName[0].toUpperCase());
    //Updates the filter to be an empty string to reset the filtering when a button is pressed twice.
    const updateFilterState = (newValue) => {
        if (newValue === props.filterLetter) {
            props.setNewLetterFilter("");
        }
        else {
            props.setNewLetterFilter(newValue);
        }
    };
    function getLetterOccurance() {
        var _a, _b;
        const alphabetDict = {};
        for (const letter of alphabetString) {
            alphabetDict[letter] = (_b = (_a = grouped[letter]) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
        }
        return alphabetDict;
    }
    const generateButtonFromLetter = (currentLetter, numberOfOccurences) => {
        const hasOccurences = numberOfOccurences > 0;
        const isActiveLetter = currentLetter === props.filterLetter;
        let buttonStyle = "pagination-button";
        if (!hasOccurences)
            buttonStyle += " pagination-button-inactive";
        if (isActiveLetter)
            buttonStyle += " pagination-button-active-letter";
        return ((0, jsx_runtime_1.jsx)("button", { type: "button", className: buttonStyle, onClick: (e) => updateFilterState(e.currentTarget.value), value: currentLetter, "aria-label": `Filtrer på bokstav ${currentLetter}${hasOccurences ? ` (${numberOfOccurences} resultater)` : " (ingen resultater)"}`, "aria-pressed": isActiveLetter, children: currentLetter }, currentLetter));
    };
    const generateAlphabet = () => {
        const occurence = getLetterOccurance();
        return alphabetString.map((currentLetter) => generateButtonFromLetter(currentLetter, occurence[currentLetter]));
    };
    return (0, jsx_runtime_1.jsx)("div", { className: "m__article-pagination-element pagination", children: generateAlphabet() });
};
exports.default = AlphabeticalPagination;
